import type { EventJson, SubscriptionJson } from '../gen/creativefabrica/notifications/v1/types_pb'
import { baseUrl, sessionId } from './common'

import { fetchRpc } from '@repo/rpc-codegen/fetch-rpc'

/**
 * Subscribes to an event via the notifications service
 * @param event - The event to subscribe to
 * @param controller - AbortController for cancelling the request
 * @param token - Optional token for authentication
 * @returns Promise with subscription response
 */
// oxlint-disable-next-line require-await
export async function subscribe(
  event: EventJson,
  controller: AbortController,
  token: string,
): Promise<{ subscriptions?: SubscriptionJson[] }> {
  return fetchRpc<{ subscriptions?: SubscriptionJson[] }>({
    url: `${baseUrl}/creativefabrica.notifications.v1.NotificationsService/Subscribe`,
    variables: {
      sessionId,
      events: [event],
    },
    controller,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

/**
 * Unsubscribes from events via the notifications service
 * @param subscriptionIds - Array of subscription IDs to unsubscribe from
 * @param controller - AbortController for cancelling the request
 * @param token - Optional token for authentication
 * @returns Promise with unsubscription response
 */
// oxlint-disable-next-line require-await
export async function unsubscribe(
  subscriptionIds: string[],
  controller: AbortController,
  token: string,
): Promise<Record<string, never>> {
  return fetchRpc<Record<string, never>>({
    url: `${baseUrl}/creativefabrica.notifications.v1.NotificationsService/Unsubscribe`,
    variables: { sessionId, ids: subscriptionIds },
    controller,
    // Override headers to make sure the token passed is the same
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}
